import createLucideIcon from '../createLucideIcon';

const Activity = createLucideIcon('ActivityIcon', [
  ['polyline', { points: '22 12 18 12 15 21 9 3 6 12 2 12', key: 'xez52g' }],
]);

export default Activity;
